module.exports = __webpack_public_path__ + "static/media/avatar-1.7214c1d4.jpg";